import React, { useCallback } from 'react';
import OrientacionView from './OrientacionView';
import './CPOControls.css';
import { useCPOContext } from '../contexts/CPOContext';

const CPOControls = ({
  orientacionSeleccionada,
  onSelectOrientacion,
  listaOrientaciones,
  cpcAprobadasCount,
  cpoPuntos,
  onPuntosChange,
  hasConfirmedRequirements,
  materias,
  updateMateriaEstado
}) => {
  const { puntos, cpcCursadas } = useCPOContext();
  const handlePuntosChange = useCallback((nuevosPuntos) => {
    // Asegurarse de que todos los valores sean números
    const puntosNormalizados = {
      total: Number(nuevosPuntos.total || 0),
      orientacionPrincipales: Number(nuevosPuntos.orientacionPrincipales || 0),
      orientacionDerivadas: Number(nuevosPuntos.orientacionDerivadas || 0),
      constitucionalProfundizado: Number(nuevosPuntos.constitucionalProfundizado || 0),
      procesalObligatorio: Number(nuevosPuntos.procesalObligatorio || 0),
      integracion: Number(nuevosPuntos.integracion || 0),
      practico: Number(nuevosPuntos.practico || 0),
      libresGeneralesCPO: Number(nuevosPuntos.libresGeneralesCPO || 0),
      filosofia: Number(nuevosPuntos.filosofia || 0),
      sociales: Number(nuevosPuntos.sociales || 0),
      procesalLibre: Number(nuevosPuntos.procesalLibre || 0)
    };

    // Verificar si realmente hay cambios
    const puntosHanCambiado = Object.entries(puntosNormalizados).some(([key, value]) => {
      return Math.abs(Number(value || 0) - Number((puntos && puntos[key]) || 0)) > 0.01;
    });
    
    if (puntosHanCambiado && onPuntosChange) {
      onPuntosChange(puntosNormalizados);
    }
  }, [puntos, onPuntosChange]);

  const currentOrientacion = typeof orientacionSeleccionada === 'string'
    ? (listaOrientaciones || []).find(o => o.id === orientacionSeleccionada) || null
    : orientacionSeleccionada || null;

  return (
    <div className="cpo-controls">
      <div className="orientacion-selector">
        <h3>Seleccionar Orientación</h3>
        <select
          value={currentOrientacion ? currentOrientacion.id : ''}
          onChange={(e) => {
            const selected = (listaOrientaciones || []).find(o => o.id === e.target.value) || null;
            onSelectOrientacion(selected);
          }}
        >
          <option value="">Elegir orientación...</option>
          {listaOrientaciones.map(orientacion => (
            <option key={orientacion.id} value={orientacion.id}>
              {orientacion.nombre}
            </option>
          ))}
        </select>
      </div>

      <div className="stats-display">
        <h4>Estado Actual</h4>
        <div>
          <div className="stats-row">
            <span>Materias CPC aprobadas:</span>
            <span className="stats-value">{(typeof cpcAprobadasCount === 'number' ? cpcAprobadasCount : cpcCursadas)}/14</span>
          </div>
          <div className="stats-row">
            <span>Puntos CPO totales:</span>
            <span className="stats-value">{(puntos?.total || 0)}/69</span>
          </div>
          {orientacionSeleccionada && (
            <>
              <div className="stats-row">
                <span>Puntos materias principales:</span>
                <span className="stats-value">{puntos?.orientacionPrincipales || 0}/12</span>
              </div>
              <div className="stats-row">
                <span>Puntos materias derivadas:</span>
                <span className="stats-value">{puntos?.orientacionDerivadas || 0}/8</span>
              </div>
            </>
          )}
        </div>
      </div>

      {currentOrientacion && (
        <OrientacionView 
          orientacion={currentOrientacion}
          puntos={puntos}
          materias={materias}
          updateMateriaEstado={updateMateriaEstado}
          onPuntosChange={handlePuntosChange}
        />
      )}
    </div>
  );
};

export default CPOControls;